<adapt-dialog [maxWidth]="640">
    <h2 adapt-dialog-title>Conversation Details</h2>

    <div adapt-dialog-content
         class="d-flex flex-column gap-3"
         *adaptLoading="!isInitialised">
        @if (chatAudits.length === 0) {
            <p>No messages found for this conversation.</p>
        } @else {
            @for (chatAudit of chatAudits; track chatAudit.rowKey; let first = $first) {
                <div class="flex-column"
                     [ngClass]="{ 'audit-section-not-first': !first }">
                    <span class="small text-muted d-flex justify-content-end">{{ chatAudit.UserMessageTimestamp | adaptDateTime }}</span>
                    <div class="user-message">
                        <span class="small text-muted">{{ data.userName }}</span>
                        <div [froalaView]="chatAudit.renderUserMessage"></div>
                        <div class="copy-row">
                            <button [adaptButtonIcon]="chatAudit.isUserMessageCopied ? 'ok' : 'copy'"
                                    class="ms-auto btn btn-blank"
                                    [disabled]="chatAudit.isUserMessageCopied"
                                    (click)="onCopyButtonClick(chatAudit, true)"></button>
                        </div>
                    </div>
                    <span class="small text-muted">{{ chatAudit.timestamp| adaptDateTime }}</span>
                    <div class="assistant-message">
                        <span class="small text-muted">Lumia Assistant</span>
                        <div [froalaView]="chatAudit.renderAssistantMessage"></div>
                        <div class="copy-row">
                            <button [adaptButtonIcon]="chatAudit.isAssistantMessageCopied ? 'ok' : 'copy'"
                                    class="ms-auto btn btn-blank"
                                    [disabled]="chatAudit.isAssistantMessageCopied"
                                    (click)="onCopyButtonClick(chatAudit, false)"></button>
                        </div>
                    </div>
                </div>
            }
        }
    </div>

    <button adapt-dialog-footer
            class="btn btn-secondary ms-auto"
            (click)="cancel()">Close</button>
</adapt-dialog>
